<template>


  <div id="app">

        <a href="https://github.com/artrayd/vuejs-freehand-svg-draw" class="github desktop">      
          <img width="149" height="149" src="https://github.blog/wp-content/uploads/2008/12/forkme_left_gray_6d6d6d.png?resize=149%2C149" class="attachment-full size-full" alt="Fork me on GitHub" data-recalc-dims="1">
        </a>
      
        <FreehandDrawSVG
          v-bind:title="drawProps.title"
          v-bind:colors="drawProps.colors"
          v-bind:bgColors="drawProps.bgColors"
          v-bind:lineColor = "drawProps.lineColor"
          v-bind:bgColor = "drawProps.bgColor"
          v-on:changeLineColor = "changeLineColor"
          v-on:changeBgColor = "changeBgColor"
          v-on:drawSubmit="saveDrawing"
          >
        </FreehandDrawSVG>

  </div>
</template>

<script>
import FreehandDrawSVG from './components/FreehandDrawSVG.vue'

export default {
  name: 'app',

  components: {
    FreehandDrawSVG
  },

  data() {
    return {
      drawProps: 
        {
          title: "Freehand SVG Draw",
          colors: ['#EAEAEA','#292929', '#00A0FF', '#FF29AA', '#FFE500', '#FF3030', '#12EB0A'],
          bgColors: ['#EAEAEA','#292929', '#00A0FF', '#FF29AA', '#FFE500', '#FF3030', '#12EB0A'],
          lineColor: "#292929",
          bgColor: "#EAEAEA"
        }
      
    }
  },

  methods: {
    changeLineColor: function(color){
      this.drawProps.lineColor = color;
    },

    changeBgColor: function(color){
      this.drawProps.bgColor = color;
    },

    saveDrawing: function(drawSvg){
      console.log (drawSvg)      
    }
  },

  mounted: function() {
  }


}
</script>

<style>
body, html{
  font-family: 'Helvetica Neue', Helvetica, arial, sans-serif;
  background: #131415;
  margin: 0;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
}

.github{
  position: fixed;
  top: 0;
  left: 0;
  opacity: .5;
  transition: opacity .2s;
}

.github:hover{
  opacity: 1;
}

</style>
